/**
 * node-iterate79
 */
(function(module){

	/**
	 * 配列の直列処理
	 */
	module.exports.ary = require('./ary.js');

	/**
	 * 関数の直列処理
	 */
	module.exports.fnc = require('./fnc.js');

	/**
	 * キュー処理
	 */
	module.exports.queue = require('./queue.js');


})(module);
